import { render, staticRenderFns } from "./addVehicleFitness.vue?vue&type=template&id=50ab52a0"
import script from "./addVehicleFitness.vue?vue&type=script&lang=js"
export * from "./addVehicleFitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports